export default __webpack_public_path__ + "static/media/logo.e10ca07d.png";